import { render, staticRenderFns } from "./LotteryAddressDialog.vue?vue&type=template&id=52a8bee8&scoped=true&"
import script from "./LotteryAddressDialog.vue?vue&type=script&lang=js&"
export * from "./LotteryAddressDialog.vue?vue&type=script&lang=js&"
import style0 from "./LotteryAddressDialog.vue?vue&type=style&index=0&id=52a8bee8&prod&lang=scss&scoped=true&"
import style1 from "./LotteryAddressDialog.vue?vue&type=style&index=1&id=52a8bee8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a8bee8",
  null
  
)

export default component.exports